import siteConfig from "../../config/siteConfig";
import { SanityFile } from "../../models/shared/SanityFile";

export const rewriteDisclaimerFileUrl = (file: SanityFile) => {
  if (!file?.asset?.originalFilename) {
    return null;
  }

  const endpointBaseUrl = siteConfig.disclaimerRelayEndpoint;

  if (!endpointBaseUrl) {
    console.warn("Failed to rewrite file URLs");
    return null;
  }

  return `${endpointBaseUrl}?fileId=${file.asset.originalFilename}`;
};
